export default "__VITE_PUBLIC_ASSET__68ea8d18__"